import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Container,
  Card,
  CardContent,
  Dialog,
  Slide,
} from "@material-ui/core";

import AppContext from "../../contexts/AppContext";
import { createIssue } from "../../actions";
import { useProjectTracker } from "../../hooks/useTracker";
import componentStyles from "../../assets/styles/components/issue_form";
import FormHeader from "../molecules/form_header";
import TextInputGroup from "../molecules/text_input_group";
import ItemSelectGroup from "../molecules/item_select_group";
import FormButtons from "../molecules/form_buttons";
import MessageSnackbar from "../molecules/message_snackbar";

const useComponentStyles = makeStyles(componentStyles);

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CreateIssueForm = (props) => {
  const { open, setOpen } = props;
  const { state, dispatch } = useContext(AppContext);
  const { t } = useTranslation();

  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);

  const unCreatable = subject === "";
  const componentClasses = useComponentStyles();

  const {
    trackers,
    selectedTrackerId,
    setSelectedTrackerId,
    getProjectTrackers,
    init,
  } = useProjectTracker();

  const handleClickCreateIssueClose = () => {
    setSubject("");
    setDescription("");
    setOpen(false);
  };
  const handleIssueCreate = async () => {
    const redmineurl = state.current.redmineurl;
    const apikey = state.current.apikey;
    const body = {
      issue: {
        subject,
        description,
        project_id: selectedProjectId,
        tracker_id: selectedTrackerId,
        assigned_to_id: state.current.user.id,
      },
    };
    const res = await createIssue(redmineurl, apikey, dispatch, body);
    if (res.errors) {
      setErrorMessage(res.errors);
    } else {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (state.current.project) {
      setSelectedProjectId(state.current.project.id);
    }
  }, [state.current]);

  useEffect(() => {
    if (selectedProjectId && init) {
      getProjectTrackers({ project_id: selectedProjectId });
    }
  }, [init, selectedProjectId]);

  useEffect(() => {
    setProjectList(state.projects);
  }, [state.projects]);

  const onChangeTracker = (e) => setSelectedTrackerId(e.target.value);
  const onChangeProject = (e) => setSelectedProjectId(e.target.value);

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClickCreateIssueClose}
        TransitionComponent={Transition}
      >
        <FormHeader
          title={t("label_issue_new")}
          handleClickClose={handleClickCreateIssueClose}
        />

        <Container
          maxWidth={false}
          component={Box}
          classes={{ root: componentClasses.containerRoot }}
        >
          <Card classes={{ root: componentClasses.cardRoot }}>
            <CardContent>
              <Grid container>
                <Grid item xs={12}>
                  <TextInputGroup
                    label={t("field_subject")}
                    value={subject}
                    onChange={setSubject}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInputGroup
                    label={t("field_description")}
                    value={description}
                    onChange={setDescription}
                    multiline={true}
                    rows={10}
                  />
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs lg={4}>
                  <ItemSelectGroup
                    label={t("label_project")}
                    items={projectList}
                    value={selectedProjectId}
                    onChange={onChangeProject}
                  />
                </Grid>
                <Grid item xs lg={4}>
                  <ItemSelectGroup
                    label={t("field_tracker")}
                    items={trackers}
                    value={selectedTrackerId}
                    onChange={onChangeTracker}
                  />
                </Grid>
              </Grid>
            </CardContent>

            <FormButtons
              onClickClose={handleClickCreateIssueClose}
              onClickSave={handleIssueCreate}
              unCreatable={unCreatable}
              closeButtonText={t("button_cancel")}
              saveButtonText={t("button_save")}
            />
          </Card>
        </Container>
      </Dialog>

      <MessageSnackbar
        message={errorMessage}
        setMessage={setErrorMessage}
        type="error"
      />
    </>
  );
};

export default CreateIssueForm;
